module.exports = __webpack_public_path__ + "img/pic_btn.bed182ed.png";